import { useState } from "react";
import { topics } from "@/mocks/home";

const moods = [
  { icon: "ri-sword-line", label: "观点对撞", desc: "两边都有理，评论区自己站队" },
  { icon: "ri-emotion-happy-line", label: "轻松搞笑", desc: "名场面截图，纯乐子不较真" },
  { icon: "ri-search-eye-line", label: "细节分析", desc: "逐帧找伏笔，看完再看一遍" },
  { icon: "ri-headphone-line", label: "配乐收藏", desc: "为了一首歌追完整部剧" },
];

export default function TopicsSection() {
  const [selected, setSelected] = useState("剧集讨论");

  return (
    <section id="topics" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-secondary-600">
              <i className="ri-price-tag-3-line w-4 h-4 flex items-center justify-center text-sm" />
              Topics
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              话题广场 · 找到你的那圈人
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              内容按话题归档，点一下就能圈定你关心的方向。喜欢对线的、喜欢看图的、喜欢抠细节的，
              都能在这里找到同类。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {moods.map((mood) => (
                <div
                  key={mood.label}
                  className="rounded-lg border border-background-200 bg-background-100 p-4"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-600">
                    <i className={`${mood.icon} w-5 h-5 flex items-center justify-center text-lg`} />
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">
                    {mood.label}
                  </h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{mood.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  全部话题 · 共 15,241 个
                </h3>
                <span className="text-xs text-foreground-500">点击选择</span>
              </div>

              <div className="mt-5 flex flex-wrap gap-2.5">
                {topics.map((topic) => {
                  const isActive = selected === topic.name;
                  return (
                    <button
                      key={topic.name}
                      type="button"
                      onClick={() => setSelected(topic.name)}
                      className={
                        isActive
                          ? "flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors"
                          : "flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                      }
                    >
                      {topic.name}
                      <span
                        className={
                          isActive
                            ? "rounded-full bg-background-50/25 px-1.5 py-0.5 text-[11px] text-background-50"
                            : "rounded-full bg-background-200 px-1.5 py-0.5 text-[11px] text-foreground-600"
                        }
                      >
                        {topic.count}
                      </span>
                    </button>
                  );
                })}
              </div>

              <div className="mt-6 rounded-md border border-primary-200 bg-primary-50 p-4">
                <p className="text-sm text-primary-800">
                  当前已选择
                  <strong className="mx-1 font-semibold">#{selected}</strong>
                  ，该话题下有
                  <strong className="mx-1 font-semibold">
                    {topics.find((topic) => topic.name === selected)?.count ?? "0"}
                  </strong>
                  条内容可以免费浏览。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}